import { Grid } from "@mui/material";
import Trip from "../PairingSnapshot/Trip/Trip";
import { useTranslation } from 'react-i18next';
import { formatNumToTime } from '../../helpers/timeHelpers';
import { getPairingSpecialCredit } from '../../helpers/creditHelpers';
import './CommonPairingView.scss';

export default function CommonPairingView({details, actualView=false, myBlockMonth}){
  const getBasePosition = (details) => {
    if(!details && !details.position) return;
    let position = "";
    for (let i = 0; i < details.position.length; i++) {
      if (details.position[i] !== null && details.position[i] !== undefined) {
        position = position + " "+ details.position[i];
      }     
    }
    return position;
  }

  const { t } = useTranslation();
  const specialCredit = getPairingSpecialCredit(details);
    return (
        <Grid item container direction='column' xs={10} lg={10} spacing={1} className='left-content'>
        <Grid item container spacing={3}>
          <Grid item>{t('detailsView.baseDom')}: {details.base}</Grid>
          <Grid item>{getBasePosition(details)}</Grid>
          <Grid item>{details.frmsPairingDesignator? details.frmsPairingDesignator: ''}</Grid>
        </Grid>
        <Grid item container spacing={3}>
          <Grid item>{t('detailsView.checkIn')}: <span className={actualView && details.checkInDeviation > 0 ? 'event-late-time' : actualView && details.checkInDeviation < 0 ? 'event-early-time' : ''}>{formatNumToTime(details.onduty)}</span> </Grid>
          <Grid item>{t('detailsView.checkOut')}: <span className={actualView && details.checkOutDeviation > 0 ? 'event-late-time' : actualView && details.checkOutDeviation < 0 ? 'event-early-time' : ''}>{formatNumToTime(details.offduty)}</span> </Grid>
          {!myBlockMonth ?
            <>
              <Grid item>{t('detailsView.credit')}: {formatNumToTime(details.credit)}</Grid>
              <Grid item>{t('detailsView.eff')}: {details.eff} </Grid>
              <Grid item>{t('detailsView.osea')}: {formatNumToTime(details.osea)} </Grid>
            </> : !actualView ?
              <>
                <Grid item>{t('detailsView.eff')}: {details.eff} </Grid>
                <Grid item>{t('myBlockMonth.initialCredit')}: <span className={actualView && details.creditDeviation > 0 ? 'event-early-time' : actualView && details.creditDeviation < 0 ? 'event-late-time' : ''}>{actualView ? formatNumToTime(details.credit + details.creditDeviation) : formatNumToTime(details.credit)}</span> </Grid>
                <Grid item>{t('myBlockMonth.initialOsea')}: {formatNumToTime(details.osea)} </Grid>
              </> : <Grid item>{t('detailsView.eff')}: {details.eff} </Grid>
          }
        </Grid>
        <Grid container item className='trip-details'>
          <Trip 
            rows={details?.segments} 
            block={details?.block} 
            tAllowance={details?.totalAllowance} 
            tafb={details?.tafb}
            redeyecredit={specialCredit.value}
            isAdgCredit={specialCredit.isAdg}
            ttgOverSeasDayCredit={details?.ttgOverSeasDayCredit || 0} 
            ttgOverSeasNgtCredit={details?.ttgOverSeasNgtCredit || 0} 
            ttgDomesticDayCredit={details?.ttgDomesticDayCredit || 0} 
            ttgDomesticNgtCredit={details?.ttgDomesticNgtCredit || 0} 
            actualView = {actualView}
            myBlockMonth={myBlockMonth}
            />
        </Grid>
        <Grid item>
          {details.remarks.length>0 ? <span className='remarks'>{t('detailsView.remarks')}:<span className='normal'>{details.remarks}</span></span> :''}
        </Grid>
      </Grid>
    )
}


